import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
// TODO: replace react-context-props
// @ts-expect-error react-context-props is no longer maintained and has no types
import { getContextualizer, withPropsFromContext } from 'react-context-props';
var defaultValue = undefined;
var DialogContentWidthContext = React.createContext !== undefined ? /*#__PURE__*/React.createContext(defaultValue) : {
  Provider: (Contextualizer => _ref => {
    var {
      children,
      value
    } = _ref;
    return /*#__PURE__*/React.createElement(Contextualizer, {
      dialogContentWidth: value
    }, children);
  })(getContextualizer({
    dialogContentWidth: PropTypes.string
  })),
  Consumer: withPropsFromContext(['dialogContentWidth'])(_ref2 => {
    var {
      children,
      dialogContentWidth
    } = _ref2;
    return children(dialogContentWidth);
  })
};

// @ts-expect-error
DialogContentWidthContext.displayName = 'DialogContentWidthContext';
export var Consumer = DialogContentWidthContext.Consumer;
export var Provider = DialogContentWidthContext.Provider;
export var withDialogContentWidth = Target => props => /*#__PURE__*/React.createElement(DialogContentWidthContext.Consumer, null, value => /*#__PURE__*/React.createElement(Target, _extends({}, props, {
  dialogContentWidth: value
})));
export var useDialogContentWidthContext = () => React.useContext(DialogContentWidthContext);
//# sourceMappingURL=index.js.map